import React from 'react';
import {
  Form, Checkbox, Spin, Icon,
} from 'antd';
import {
  Box, Text,
} from '../../shared/components';
import InlineCard from '../components/InlineCard';
import Girl from '../../../assets/img/Girl.png';


export default function TipologiasTab({
  tipologias, form, noConformidades, onChangeTipologias,
}) {
  const { getFieldDecorator } = form;
  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
  let content = '';
  const { listado, loading } = tipologias;
  const { seleccionada } = noConformidades;
  let { tipologias: tipologiasArray } = seleccionada;
  tipologiasArray = (typeof (tipologiasArray) !== 'undefined') ? tipologiasArray : [];
  if ((typeof (listado) === 'undefined') || (listado === null) || (listado.length === 0)) {
    for (let i = 0; i < tipologiasArray.length; i += 1) {
      listado[i] = { id: tipologiasArray[i] };
    }

    content = (
      <InlineCard
        headerText="TIPOLOGÍAS"
        content={(
          <Box
            px={5}
            py={3}
            style={{
              color: '#8798AD',
              fontFamily: 'Rubik',
              fontSize: '15px',
              lineHeight: '22px',
              textAlign: 'center',
            }}
          >
            <Text style={{ color: '#2E384D' }}>No hay tipologías disponibles</Text>
            <img
              style={{
                height: '297px',
                width: '167px',
                marginTop: '32px',
                marginBottom: '24px',
              }}
              alt=""
              src={Girl}
            />
            <Box>
              <Text style={{ color: '#2E384D' }}>Selecciona primero</Text>
              <Text>Clientes, Proveedores, RRHH Causantes o Procesos</Text>
            </Box>

          </Box>
         )}
      />
    );
  } else {
    content = (
      <Box py={3}>
        <InlineCard
          headerText="TIPOLOGÍAS"
          content={(
            <Box px={5} py={3}>
              <Spin indicator={antIcon} spinning={loading} size="large">
                {listado.map(item => (
                  <Form.Item key={item.id}>
                    {getFieldDecorator(`tipologias[${item.id}]`, {
                      initialValue: (tipologiasArray.indexOf(item.id) >= 0),
                      valuePropName: 'checked',
                    })(
                      <Checkbox onChange={e => onChangeTipologias(e)}>{item.nombre}</Checkbox>,
                    )}
                  </Form.Item>
                ))}
              </Spin>
            </Box>
         )}
        />
      </Box>
    );
  }

  return content;
}
